export { default } from './responsive-tooltip';
